import { Suspense } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';
import { LinearProgress } from '@rossum/ui/material';
import { BeamerProvider } from '../../beamer/BeamerProvider';
import { REACT_QUERY_DEVTOOLS_ENABLED } from '../../constants/config';
import { DateLocalizationProvider } from '../../DateLocalizationProvider';
import { QuickSearchContextProvider } from '../../features/quick-search/QuickSearchContext';
import { queryClient } from '../../lib/queryClient';
import store from '../../redux/configureStore';
import Router from '../../routes';
import { RuiThemeProvider } from '../../RuiThemeProvider';
import UnleashProvider from '../../unleash/Unleash';
import { EasterEggProvider } from '../EasterEggProvider';
import { LoginAnimationContextProvider } from '../Login/LoginAnimationContext';
import ConnectedIntlProvider from './ConnectedIntlProvider';
import GlobalErrorBoundary from './GlobalErrorBoundary/GlobalErrorBoundary';
import ObservableProvider from './ObservableProvider';

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ObservableProvider>
      <Provider store={store}>
        <Suspense fallback={<LinearProgress />}>
          <UnleashProvider>
            <EasterEggProvider>
              <RuiThemeProvider>
                <LoginAnimationContextProvider>
                  <ConnectedIntlProvider>
                    <DateLocalizationProvider>
                      <GlobalErrorBoundary>
                        <BeamerProvider>
                          <QuickSearchContextProvider>
                            <Router />
                          </QuickSearchContextProvider>
                        </BeamerProvider>
                      </GlobalErrorBoundary>
                      {REACT_QUERY_DEVTOOLS_ENABLED && (
                        <ReactQueryDevtools initialIsOpen={false} />
                      )}
                    </DateLocalizationProvider>
                  </ConnectedIntlProvider>
                </LoginAnimationContextProvider>
              </RuiThemeProvider>
            </EasterEggProvider>
          </UnleashProvider>
        </Suspense>
      </Provider>
    </ObservableProvider>
  </QueryClientProvider>
);

export default App;
